// Catalogue shared through the Cosmos entry only. Consumers pass their active locale.
export const conflictMessages = {
  tr: {
    default: { title: 'Kayıt başka biri tarafından değiştirildi', body: 'Girdiğiniz veriler korunuyor; güncel kaydı yükleyip yeniden deneyebilirsiniz.', action: 'Güncel kaydı yükle' },
    structure: { title: 'Holding yapısı değişti', body: 'Şirket listesini yenileyin; girdiğiniz veriler korunuyor.', action: 'Şirket listesini yenile' },
    'entra-503': { title: 'Entra’ya ulaşılamadı', body: 'Kişi Entra’da doğrulanamadı; işlem uygulanmadı. Bağlantı düzelince yeniden deneyin.', action: 'Yeniden dene' },
    changed: 'Değişen alanlar:', loading: 'Güncel kayıt yükleniyor.',
  },
  en: {
    default: { title: 'Someone else changed this record', body: 'Your entered data is preserved; load the latest record and try again.', action: 'Load latest record' },
    structure: { title: 'The holding structure changed', body: 'Refresh the company list; your entered data is preserved.', action: 'Refresh company list' },
    'entra-503': { title: 'Entra could not be reached', body: 'The person could not be verified in Entra; the action was not applied. Try again when the connection is restored.', action: 'Try again' },
    changed: 'Changed fields:', loading: 'Loading the latest record.',
  },
}
export type ConflictNoticeLabels = typeof conflictMessages.tr

export { capabilityMessages } from './capabilityMessages'
